import {
    Typography,
    Box,
    Card,
    CardContent,
    LinearProgress
} from '@mui/material';
import BlockIcon from "@mui/icons-material/Block";
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export function CurrentPlanStatus({ remainingAttempts, setShowUpgradePlan, totalSessions, isTrialPack }) {
    const attemptsPercentage = (remainingAttempts / totalSessions) * 100;
    const isLowAttempts = remainingAttempts <= 3 && remainingAttempts >= 0;
    const isZeroAttempts = remainingAttempts === 0;

    return (
        <Card sx={{ borderRadius: 3, overflow: "hidden", boxShadow: 6, width: '90vw', mb: 3 }}>
            {isZeroAttempts && <Box sx={{ bgcolor: "error.main", color: "#ffffff", p: 2 }}>
                <Typography fontWeight="bold" display="flex" alignItems="center" gap={1}>
                    {isZeroAttempts ? "Attempts Exhausted" : "No Attempts Remaining"}
                    <Typography variant="body2">
                        {isZeroAttempts && (!isTrialPack)
                            ? ` — Buy more to restore access.`
                            : " — Your trial limit has been reached. Buy more to continue practicing."}
                    </Typography>
                </Typography>
            </Box>}
            {(isTrialPack && !isZeroAttempts) && (
                <Box
                    sx={{
                        background: '#f59e0b',
                        color: "#ffffff",
                        p: 1.5
                    }}
                >
                    <Typography display="flex" alignItems="center" gap={1}>
                        <FeatherIcon size="1.5em" icon="zap" />
                        <Typography fontWeight="600" >
                            You're on a Trial
                        </Typography>
                        — Buy more to get more practice attempts.
                    </Typography>
                </Box>
            )}

            <CardContent
                sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2,
                    marginBottom: 0
                }}
            >
                <Box sx={{ width: '50%' }}>

                    {/* Progress Bar */}
                    <Box sx={{ mt: 1 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant='h6' fontWeight="600" fontSize={'17px'}>
                                Remaining Attempts:
                            </Typography>
                            <Box
                                component="span"
                                sx={{
                                    fontWeight: 700,
                                    mr: 2,
                                    color: isZeroAttempts
                                        ? "#dc2626"
                                        : isLowAttempts ? "#f97316" : "#008037"
                                }}
                            >
                                {remainingAttempts} / {totalSessions}
                            </Box>
                        </Box>
                        <LinearProgress
                            variant="determinate"
                            value={attemptsPercentage}
                            sx={{
                                height: 10,
                                width: '100%',
                                borderRadius: 5,
                                "& .MuiLinearProgress-bar": {
                                    background: isZeroAttempts
                                        ? "linear-gradient(90deg, #dc2626, #b91c1c)"
                                        : isLowAttempts
                                            ? "linear-gradient(90deg, #fb923c, #f97316)"
                                            : "linear-gradient(90deg, #39a96a, #008037)"
                                }
                            }}
                        />
                        {isLowAttempts && (
                            <Typography variant="caption" color={!isZeroAttempts ? "#f97316" : "#dc2626"}>
                                {!isZeroAttempts ? (
                                    <><WarningAmberIcon sx={{ color: "#f97316", fontSize: 15 }} /> Running low on attempts!</>
                                ) : (
                                    <><BlockIcon sx={{ color: '#dc2626', fontSize: 15 }} /> No Attempts Remaining</>
                                )}
                            </Typography>
                        )}
                    </Box>
                </Box>
                {/* Button container */}
                <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
                    <AivagamButton
                        classStyles={{
                            fontWeight: '600',
                            fontSize: '15px',
                            width: '180px',
                            height: '50px',
                            borderRadius: '10px',
                            boxShadow: "none"
                        }}
                        type="confirm"
                        buttonText={'Buy More'}
                        onClick={() => setShowUpgradePlan(true)}
                    />
                </Box>
            </CardContent >
            {/* Additional Messages */}
            {(!isZeroAttempts && isTrialPack) && (
                <Box sx={{ bgcolor: "#fef3c7", border: "1px solid #fb923c", p: 2, m: 1, borderRadius: '8px' }}>
                    <Typography variant="body2" color="#fb923c">
                        <strong>Limited Access:</strong> Your trial includes {totalSessions} practice attempts. Buy more
                        for more practice attempts
                    </Typography>
                </Box>
            )}
            {isZeroAttempts && (
                <Box sx={{ bgcolor: "#fee2e2", border: "1px solid #fecaca", p: 2, m: 1, borderRadius: '8px' }}>
                    <Typography variant="body2" color="#dc2626">
                        {(isZeroAttempts && !isTrialPack) ? (
                            <>
                                <BlockIcon sx={{ color: '#dc2626', fontSize: 15 }} />
                                You've reached your limit. Buy more to resume practicing.
                            </>
                        ) : (
                            <>
                                <BlockIcon sx={{ color: '#dc2626', fontSize: 15 }} />
                                You've used all attempts. Buy more to continue practicing.
                            </>
                        )}
                    </Typography>
                </Box>
            )}
        </Card >
    )
}